import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@shared';
import { TasksDashboard } from '@shared/models/tasks-dashboard';
import { Pagination } from '@shared/pagination';
import { Observable } from 'rxjs';
import { MojoTasksService, Task, TasksEntityType } from 'mojo-tasks';
import { TaskSwimLaneType } from '@modules/tasks/models/task-swin-lane-type';

@Injectable()
export class TasksService extends ApiService<Task> implements MojoTasksService {
  constructor(http: HttpClient) {
    super(http);
    this.url = 'tasks';
  }

  getMojoTasks(
    entityType: TasksEntityType,
    entityId: number,
    page?: number,
    size?: number,
    myTasks: boolean = false,
    anonymization: boolean = false,
  ): Observable<Pagination<Task>> {
    const sizeToSend = size > 0 ? size : 5;
    const params = { anonymization, size: sizeToSend, page };

    return this.get({
      url: `/${entityType}/${entityId}`,
      params,
    });
  }

  getAllDashboardTasks(anonymization: boolean = false): Observable<TasksDashboard> {
    return this.get({ url: '/dashboard', params: { anonymization } });
  }

  createTask(
    task: Partial<Task>,
    entityType?: string,
    entityId?: number,
    anonymization?: boolean,
  ): Observable<Task> {
    return this.post({
      url: `/${entityType}/${entityId}`,
      body: task,
      params: { anonymization, assignedUser: task.assignedUser },
    });
  }

  completeTask(taskId: number): Observable<void> {
    return this.post({ url: `/${taskId}?complete` });
  }

  removeTask(taskId: number): Observable<Task> {
    return this.post({ url: `/${taskId}?remove` });
  }

  patchTask(task: Partial<Task>, anonymization: boolean = false): Observable<Task> {
    return this.patch({
      url: `/${task.id}`,
      body: task,
      params: { anonymization, assignedUser: task.assignedUserId?.toString() },
    });
  }

  getDashboardTasksByType(type: TaskSwimLaneType, page: number, anonymization: boolean = false) {
    return this.get({
      url: `/dashboard?type=${translateEnum(type)}`,
      params: { anonymization, offset: page },
    });
  }
}

function translateEnum(type: TaskSwimLaneType): string {
  switch (type) {
    case TaskSwimLaneType.OVERDUE:
      return 'OVERDUE';
    case TaskSwimLaneType.TODAY:
      return 'TODAY';
    case TaskSwimLaneType.TOMORROW:
      return 'TOMORROW';
    case TaskSwimLaneType.NEXT_7_DAYS:
      return 'NEXT_7_DAYS';
    case TaskSwimLaneType.UPCOMING:
      return 'UPCOMING';
  }
}
